module.exports = __webpack_public_path__ + "media/components/shared/nav_bar_images/x-62937d1bd0fc1ca3b458efd5cfb749fe.svg";